<template>
    <div class="home">
        <hero />
        <div v-if="source == 'Search'">
            <search />
        </div>
        <div v-if="source == 'Recipes' || source == 'Category'">
            <recipes />
        </div>
        <div v-if="source == 'Recipe'">
            <recipe />
        </div>
    </div>
</template>

<script>
import hero from '@/components/common/Hero'
import search from '@/components/pages/Search'
import recipes from '@/components/pages/Recipes'
import recipe from '@/components/pages/Recipe'
export default {
    computed: {
        source(){
            return this.$route.name
        }
    },
    components: {
        hero,
        search,
        recipes,
        recipe
    }
}
</script>